export type SettleTracker = {
  onPendingChange: (pending: number) => void;
  settled: Promise<void>;
};

type Options = {
  /** Settle no matter what after this long. */
  timeoutMs: number;
  /** A component that never reports any work settles after this quiet period. */
  idleMs: number;
};

/**
 * Turns a component's reports of how many requests it has in flight into one promise that resolves
 * when work that started has finished, when nothing ever starts, or when the ceiling is reached.
 */
export const createSettleTracker = ({ timeoutMs, idleMs }: Options): SettleTracker => {
  let resolveSettled!: () => void;
  const settled = new Promise<void>(resolve => { resolveSettled = resolve; });
  let sawWork = false;
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    clearTimeout(ceiling);
    clearTimeout(idle);
    resolveSettled();
  };

  const ceiling = setTimeout(finish, timeoutMs);
  const idle = setTimeout(finish, idleMs);

  const onPendingChange = (pending: number) => {
    if (done) return;
    if (pending > 0) {
      sawWork = true;
      clearTimeout(idle);
    } else if (sawWork) {
      finish();
    }
  };

  return { onPendingChange, settled };
};
